var FcStoragesInputModule = /** @class */ (function () {
    function FcStoragesInputModule() {
    }
    return FcStoragesInputModule;
}());
export { FcStoragesInputModule };
